import React from 'react';
import { connect } from 'react-redux';
import { actionCreators} from './store';
import history from 'common/history'
import Header from 'component/header'
import './index.css'
import CourseBox from './components/courseBox';
import Faceidentify from './components/faceIdentify';
import { Link } from "react-router-dom";
import axios from 'axios';
import userRequest, { userApi } from 'common/request';
import { Button, Modal } from 'antd-mobile';

class Home extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            title:'人脸身份认证',
            modalError: false,
            modalSuccess: false,
            address: ''
        }
    }
    componentWillMount() {
        const { getSetData,setUserInfo, getCourseList ,projectList,liveList,experimentList } = this.props;
        getSetData();
        //setUserInfo();
        getCourseList();
    }

    getCookie(name){
        let arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)")
        if (arr = document.cookie.match(reg)) return unescape(arr[2])
        else return null
    }

    showModal = key => (e) => {
        // e.preventDefault(); // 修复 Android 上点击穿透
        this.setState({
            [key]: true,
        });
    }

    onClose = key => () => {
        this.setState({
          [key]: false,
        });
        if(this.state.address.length !== 0) {
            window.location = this.state.address
        }
    }

    async componentDidMount() {
        userRequest.get( userApi.userInfo).then(res => {
            if(res.params.faceAuth !== true) {
                axios.get(userApi.rentConfig, {params: {id: res.params.tenant_id}}).then(res => {
                    if(res.data.params.list[0].data.faceId.need !== "no") {
                        this.refs.child.showModal('modal1')();
                    }
                }).catch(err => console.log(err))
            }else {
                this.refs.child.onClose('modal1')();
            }
        }).catch(err => console.log(err))

        // if(localStorage.getItem('userinfo') !== null){
        //     if(JSON.parse(localStorage.getItem('userinfo')).need !== "no") {
        //         userRequest.get(window.AppConfig.mainIP + userApi.userInfo).then(res => {
        //             if(res.params.faceAuth !== true) {
        //                 this.refs.child.showModal('modal1')();
        //             }
        //         }).catch(err => console.log(err))
        //     }
        // }
            
            let token = this.getCookie('_token')
            let pattern=/{i:\d+;s:\d+:"_token";i:\d+;s:\d+:"(.+?)";}/
            token = pattern.exec(decodeURIComponent(token))
            token = token?`${token[1]}`: '';
            
            let callBack = window.location.href.includes('orderNo') || window.location.href.includes('BizToken')? window.location.href: ''
            let origin = callBack.slice(0, callBack.indexOf("?"))
            this.setState(() => { return {address: origin}})
            callBack = callBack.slice(callBack.indexOf("?"))
            console.log(callBack)
            
            var obj = {}; 
            if(callBack.length !== 0) {
                callBack.replace(/([^?=&]+)=([^?=&]+)/g, function () { 
                    obj[arguments[1]] = arguments[2]; 
                });
                await axios({
                    method: 'get',
                    url: userApi.firstIdentifyCallback +callBack,
                    headers: {
                        'Authorization': `bearer ${token}`
                    }
                    // params: {  'orderNo': obj.orderNo,
                    //     'signature': obj.signature,
                    //     'code': obj.code,
                    //     'newSignature': obj.newSignature,
                    //     'h5faceId': obj.h5faceId,
                    //     'liveRate': obj.liveRate
                    // }
                }).then(response => {
                    if (response !== undefined && ((response.status === 200 || response.status === 304 || response.status === 400))) {
                        // return response.data // 直接返回http response响应的data,此data会后端返回的数据数据对象，包含后端自定义的code,message,data属性
                        if(response.data.code == 200 && response.data.msg && response.data.msg === 'Success') {
                            this.showModal('modalSuccess')()
                        }
                    }else {
                        this.showModal('modalError')()
                    }
                }).catch(err => {
                    this.showModal('modalError')
                    console.log(err)
                })
                // if(obj.signature == undefined) {
                //     localStorage.setItem('userIdentify', false)
                // }else {
                //     localStorage.setItem('userIdentify', true)
                // }
            }

    }

    render() {
        const { projectList, liveList, experimentList ,settingInfo,userinfo} = this.props;
        if(settingInfo){
            document.getElementsByTagName('meta')['description'].content=settingInfo.get('web_title');
            document.title = settingInfo.get('web_title');
            // 主动触发微信title变更
            let i = document.createElement('iframe');
            i.style.display = 'none';
            i.onload = function() {
                setTimeout(function(){
                    i.remove();
                }, 9)
            };
            document.body.appendChild(i);
        }
        return (
            <div>
              <Header setting={settingInfo} info={userinfo}/>
              <div className="container">
                  <CourseBox title='直播课程' imgUrl='title_icon2' type="live" data={liveList && liveList.size!=0 ? liveList.get('models') : ''}/>
                  <CourseBox title='点播课程' imgUrl='title_icon1' type="project" data={projectList && projectList.size!=0 ? projectList.get('models') : ''}/>
                  <Faceidentify ref="child"></Faceidentify>
                {/*<CourseBox title='实验课程' imgUrl='title_icon3' type="experiment" data={experimentList && experimentList.size!=0 ? experimentList.get('models') : ''}/>*/}
              </div>
              <Modal
                visible={this.state.modalError}
                transparent
                maskClosable={false}
                title="人脸身份认证"
                style={{ position: 'sticky'}}>
                    <div style={{ height: '90%', overflow: 'scroll' }}>
                        <div className="condition">
                            <img src={require('./img/error.png')} className="error-img margin"></img>
                            <span className="co-des-title margin">认证失败</span>
                            <span className="co-tips-text margin">人脸身份认证未及时响应，本次认证失败</span>
                            <button className="submit-return" onClick={this.onClose('modalError')}>返回</button>
                        </div>
                    </div>
                </Modal>
                <Modal
                visible={this.state.modalSuccess}
                transparent
                maskClosable={false}
                title="人脸身份认证"
                style={{ position: 'sticky'}}>
                    <div style={{ height: '90%', overflow: 'scroll' }}>
                        <div className="condition">
                            <img src={require('./img/success.png')} className="error-img margin"></img>
                            <span className="co-des-title margin">认证成功</span>
                            <button className="submit-return" onClick={this.onClose('modalSuccess')}>返回</button>
                        </div>
                    </div>
                </Modal>
            </div>
        )

    }
}


const mapState = (state) => ({
    settingInfo:state.getIn(['home','settingInfo']),
    projectList: state.getIn(['home', 'data', 'project']),
    liveList: state.getIn(['home', 'data', 'live']),
    experimentList: state.getIn(['home', 'data', 'experiment']),
    userinfo:state.getIn(['home','userinfo'])
})


const mapDispatch = (dispatch) => ({
    getCourseList(types, page, perpage) {
        dispatch(actionCreators.getCourseList(types, page, perpage))
    },
    getSetData(){
        dispatch(actionCreators.getSettingData())
    },
    setUserInfo(){
        dispatch(actionCreators.setUserInfo())
    }
})
export default connect(mapState, mapDispatch)(Home);
